import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';
import { UpdateMileageBucketProps } from 'shared/service';
import { Freight, ObjectTyped } from 'shared/types';

export function useUpdateMileageBucket() {
  const { freightService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const mutation = useMutation<Freight[], Error, UpdateMileageBucketProps>(
    request => freightService.updateMileageBucket(request),
    {
      onSuccess: data => {
        queryClient.setQueryData<Freight[]>(QUERY_KEYS.freight, old => {
          if (old) {
            const updatedRowsMap = ObjectTyped.fromEntries(data.map(c => [c.id, c]));
            return old.map(grid => (updatedRowsMap[grid.id] ? updatedRowsMap[grid.id] : grid));
          }
          return [];
        });
        enqueueSnackbar('Mileage bucket was updated', { variant: 'success' });
      },
      onError: () => {
        enqueueSnackbar('There was a problem updating mileage bucket', { variant: 'error' });
      },
    }
  );

  return mutation;
}
